import React, { FunctionComponent } from 'react'
import { OrderedListItemModel } from 'Models'
import {
	BtnComponent,
	UISizes,
	UITypes,
	CustomColumnsComponentProps,
	GridBaseItem,
	OpenedComponentProps,
	GridControlExpandWrapperStyled,
	GridColText,
	GridCheckWrapperStyled,
} from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'
import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox'
import { Id } from 'Src/types/aliases'
import {
	GridRowColumnLIStyled,
	GridRowColumnULStyled,
	GridRowWrapperStyled,
	OpenedComponentWrapper,
} from './styled'

interface ComponentProps<Item> {
	columns: OrderedListItemModel[]
	item: Item
	customActions?: Record<string, Callback>
	CustomColumnsComponent: FunctionComponent<CustomColumnsComponentProps>
	expandable?: boolean
	opened?: number
	checkable?: boolean
	onCheck?: Callback<boolean>
	isChecked?: boolean
	disableCheck?: boolean
	OpenedComponent?: FunctionComponent<OpenedComponentProps>
	setOpened?: Callback
	onOpen?: Callback
	className?: string
	idActive?: Id
	rowClick?: Callback
}
export const GridRow = <Item extends GridBaseItem = GridBaseItem>({
	columns,
	item,
	CustomColumnsComponent,
	customActions,
	expandable = false,
	opened,
	checkable,
	onCheck,
	isChecked = false,
	disableCheck,
	OpenedComponent,
	setOpened,
	onOpen,
	className,
	idActive,
	rowClick,
}: ComponentProps<Item>) => {
	const isOpen = item.id === opened

	const setOpen = (id: Id) => {
		setOpened?.(id)
		if (id) onOpen?.(id)
	}

	const getCheckbox = () =>
		checkable ? (
			<GridCheckWrapperStyled absolute={isOpen}>
				<Checkbox
					onChange={(e: CheckboxChangeEvent) => onCheck(e.target.checked)}
					checked={isChecked}
					disabled={disableCheck}
				/>
			</GridCheckWrapperStyled>
		) : null

	const getCell = (col: OrderedListItemModel) => (
		<GridColText>
			{col.custom ? (
				<CustomColumnsComponent slug={col.slug} item={item} customActions={customActions} />
			) : (
				item[col.slug]
			)}
		</GridColText>
	)

	const getControl = () => (
		<GridControlExpandWrapperStyled absolute={isOpen} width={31}>
			<BtnComponent
				icon={isOpen ? 'chevron-down' : 'chevron-right'}
				size={UISizes.SMALL}
				type={!isOpen && UITypes.PASSIVE}
				link={isOpen}
				onClick={() => setOpen(!isOpen ? item.id : null)}
			/>
		</GridControlExpandWrapperStyled>
	)

	return (
		<GridRowWrapperStyled
			className={className}
			bordered={isOpen}
			onClick={() => rowClick?.(item?.id)}
		>
			{isOpen && OpenedComponent ? (
				<OpenedComponentWrapper>
					{getCheckbox()}
					<OpenedComponent
						item={item}
						columns={columns}
						opened={opened}
						setOpen={setOpen}
						getCell={getCell}
					/>
					{getControl()}
				</OpenedComponentWrapper>
			) : (
				<GridRowColumnULStyled isActive={idActive === item?.id}>
					{getCheckbox()}

					{columns.map((col: OrderedListItemModel) => (
						<GridRowColumnLIStyled key={col.slug} width={col.width}>
							{getCell(col)}
						</GridRowColumnLIStyled>
					))}

					{expandable && getControl()}
				</GridRowColumnULStyled>
			)}
		</GridRowWrapperStyled>
	)
}
